import { fromJS } from 'immutable';
import { visibleColumns } from './earthquakeReduxConstants';
import { resolveErrors } from '../../../components/grid/resultGridUtils';

export const EARTHQUAKE_DATA_CLEAR = 'EARTHQUAKE_DATA_CLEAR';

export const EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST = 'EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST';
export const EARTHQUAKE_DATA_DELETE_EARTHQUAKE_SUCCESS = 'EARTHQUAKE_DATA_DELETE_EARTHQUAKE_SUCCESS';
export const EARTHQUAKE_DATA_DELETE_EARTHQUAKE_FAILURE = 'EARTHQUAKE_DATA_DELETE_EARTHQUAKE_FAILURE';

export const EARTHQUAKE_DATA_REGION_FAILURE = 'EARTHQUAKE_DATA_REGION_FAILURE';
export const EARTHQUAKE_DATA_REGION_REQUEST = 'EARTHQUAKE_DATA_REGION_REQUEST';
export const EARTHQUAKE_DATA_REGION_SUCCESS = 'EARTHQUAKE_DATA_REGION_SUCCESS';

export const EARTHQUAKE_DATA_SAVE_OPEN_CONFIRMATION = 'EARTHQUAKE_DATA_SAVE_OPEN_CONFIRMATION';
export const EARTHQUAKE_DATA_SAVE_CANCEL_CONFIRMATION = 'EARTHQUAKE_DATA_SAVE_CANCEL_CONFIRMATION';
export const EARTHQUAKE_DATA_CANCEL_EDIT = 'EARTHQUAKE_DATA_CANCEL_EDIT';
export const EARTHQUAKE_DATA_EDIT = 'EARTHQUAKE_DATA_EDIT';
export const EARTHQUAKE_DATA_BULK_EDIT_REQUEST = 'EARTHQUAKE_DATA_BULK_EDIT_REQUEST';
export const EARTHQUAKE_DATA_BULK_EDIT_SUCCESS = 'EARTHQUAKE_DATA_BULK_EDIT_SUCCESS';
export const EARTHQUAKE_DATA_BULK_EDIT_FAILURE = 'EARTHQUAKE_DATA_BULK_EDIT_FAILURE';

export const EARTHQUAKE_DATA_TOGGLE_COLUMN = 'EARTHQUAKE_DATA_TOGGLE_COLUMN';

const initialState = fromJS({
  deleting: false,
  fetchedRegions: false,
  regions: [],

  visibleColumns,

  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const earthquakeDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case EARTHQUAKE_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case EARTHQUAKE_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));

    case EARTHQUAKE_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case EARTHQUAKE_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));

    case EARTHQUAKE_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case EARTHQUAKE_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case EARTHQUAKE_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));

    case EARTHQUAKE_DATA_CLEAR:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
      }));

    case EARTHQUAKE_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST:
      return state.set('deleting', true);
    case EARTHQUAKE_DATA_DELETE_EARTHQUAKE_SUCCESS:
    case EARTHQUAKE_DATA_DELETE_EARTHQUAKE_FAILURE:
      return state.set('deleting', false);


    case EARTHQUAKE_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case EARTHQUAKE_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case EARTHQUAKE_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    default:
      return state;
  }
};
